module.exports = __webpack_public_path__ + "assets/media/contact-card.d35b33fb.svg";